import { apiClient } from "./authService";

export const manageSlots = async (slotData: {
  action: "open" | "close";
  date: string;
  start_time: string;
  end_time: string;
  unit_id: string;
  reason?: string;
  notes?: string;
  blockId?: string; // required for "open"
}) => {
  const buildDateTime = (date: string, time: string) => {
    // First try the native parser (covers standard HH:mm values)
    const native = new Date(`${date}T${time}:00`);
    if (!isNaN(native.getTime())) return native;

    // Fallback: manually set hours/minutes to tolerate values like "24:00"
    const [hhRaw = "0", mmRaw = "0"] = String(time).split(":");
    const hh = parseInt(hhRaw, 10);
    const mm = parseInt(mmRaw, 10);
    if (Number.isNaN(hh) || Number.isNaN(mm)) {
      throw new Error("Invalid time format for slot management");
    }
    const base = new Date(date);
    base.setHours(hh, mm, 0, 0);
    return base;
  };

  const startDt = buildDateTime(slotData.date, slotData.start_time);
  let endDt = buildDateTime(slotData.date, slotData.end_time);

  // If the end time is earlier/equal to the start, treat it as next-day (overnight range)
  if (endDt.getTime() <= startDt.getTime()) {
    endDt = new Date(endDt.getTime());
    endDt.setDate(endDt.getDate() + 1);
  }

  const start_at = startDt.toISOString();
  const end_at = endDt.toISOString();

  if (slotData.action === "close") {
    return createBlock({
      unit_id: slotData.unit_id,
      start_at,
      end_at,
      reason: slotData.reason,
      notes: slotData.notes,
    });
  }

  if (slotData.action === "open") {
    if (!slotData.blockId) {
      throw new Error("Block ID is required to open a slot");
    }

    return removeBlock(slotData.blockId, { start_at, end_at });
  }
};

//new
export const removeBlock = async (
  blockId: string,
  payload?: { start_at?: string; end_at?: string },
) => {
  const res = await apiClient.request<any>({
    method: 'DELETE',
    url: `/appointments/block/${blockId}`,
    data: payload,
  });
  return res.data;
}
export const createBlock = async (payload: {
  unit_id: string;
  start_at: string;
  end_at: string;
  reason?: string;
  notes?: string;
}) => {
  const res = await apiClient.post<any>("/appointments/block", payload);
  return res.data;
};

export const getBlockedSlots = async (
  unitId: string,
  options?: { viewType?: "day" | "week" | "month"; date?: string },
) => {
  const params = new URLSearchParams();
  if (options?.viewType) params.append("viewType", options.viewType);
  if (options?.date) params.append("date", options.date);

  const query = params.toString() ? `?${params.toString()}` : "";

  const res = await apiClient.get<any>(
    `/appointments/unit/${unitId}/slots${query}`,
  );
  return res.data;
};

// Backward-compatible helper used by Appointment.tsx
export const getSlots = async (params: {
  business_id?: string;
  unit_id?: string;
  start_date?: string;
  end_date?: string;
  viewType?: "day" | "week" | "month";
  date?: string;
}) => {
  const unitId = params.unit_id;
  if (!unitId) {
    throw new Error("unit_id (or business_id) is required to fetch slots");
  }

  const res = await apiClient.get<any>(`/appointments/unit/${unitId}/slots`, {
    params: {
      start_date: params.start_date,
      end_date: params.end_date,
      viewType: params.viewType,
      date: params.date,
    },
  });

  return res.data;
};
